import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Icon, Input } from 'antd';
import { debounce } from 'lodash';

import s from './Search.pcss';


class Search extends Component {
  static propTypes = {
    value: PropTypes.string,
    onSearch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    value: '',
  };


  state = {
    value: this.props.value,
  };


  finishSearch = () => this.setState({ value: '' });
  debounceSearch = debounce(this.props.onSearch, 500);

  onChangeSearchValue = e =>
    this.setState({ value: e.target.value }, () => this.debounceSearch(this.state.value));

  render() {
    const { value } = this.state;
    return (
      <div className={s.inputContainer}>
        <Input
          className={s.searchInput}
          value={value}
          onChange={this.onChangeSearchValue}
          placeholder="Поиск"
        />
        <Icon type="search" className={s.inputSearchIcon} theme="outlined" />
        <Icon type="close" className={s.searchCloseIcon} onClick={this.finishSearch} />
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/shared/components/Search/Search.js